import { render, staticRenderFns } from "./MenuDealCategory.vue?vue&type=template&id=035a5bdd&scoped=true"
import script from "./MenuDealCategory.vue?vue&type=script&lang=js"
export * from "./MenuDealCategory.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "035a5bdd",
  null
  
)

export default component.exports